import { RequestHeader } from './RequestHeader';
import RequestMealsTableApp from '../Functionality/RequestMealsTableApp';
import CustomTable from '../../../../../components/table/CustomTable';
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import {CheckOutlineIcon} from "../../../../../components/buttons/IconButtons";
import React from "react";
import CancelModal from "../../Schedules/Modal/CancelModal";
import {getInfoParagraphByStatus} from "../../../ApprovalTracker/Model/Model";
import {STATUS_MODEL} from "../../../../../enums/statusEnum";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const RequestMealTable = ({
    optionView,
    handleBtnRequest,
    handleBtnHistory,
    setItemSelected,
    setSummaryModalShow,
    modified,
    setModified,
    setBodyForExport,
    setCriteria,

    searchElement,
    setSearchElement,
    option,
    setSearch,
    simpleSearch,
    setSimpleSearch
}) => {
    const {
        t,
        tableId,
        searchId,
        thead,
        tbody,
        getActionsButtons,
        pagination,
        showApproveButton,
        showApprovedModal,
        setShowApprovedModal,
        handleApprovalAll,
        selectedList,
        setSelectedList,
        isAllChecked,
        setIsAllChecked,
        handleCheckboxChange,
        handleDeleteAll,
        listDisabled,

        rowsPerPage,
        results,
        setResults,
        getData
    } = RequestMealsTableApp({
        setItemSelected,
        setSummaryModalShow,
        modified,
        setModified,
        searchElement,
        setBodyForExport,
        option
    });

    return (
        <>
            <RequestHeader
                optionView={optionView}
                handleBtnRequest={handleBtnRequest}
                handleBtnHistory={handleBtnHistory}
                searchId={searchId}
                setBodyForExport={setBodyForExport}
                setResults={setResults}
                results={results}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                option={option}
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                simpleSearch={simpleSearch}
                setSimpleSearch={setSimpleSearch}
                getData={getData}
            />
            <div className='d-flex justify-content-end px-4 mb-3'>
                {showApproveButton && (
                    <ButtonAction
                        Icon={CheckOutlineIcon}
                        id={'btn_rsv_approve'}
                        extraClassName={'border-full-success-600 background-general-00'}
                        className={'border-full-success-600 background-general-00'}
                        iconClass={'h-32px w-32px mr-0'}
                        iconProps={'icon'}
                        onClick={() => {
                            setShowApprovedModal(true);
                        }}
                    />
                )}
            </div>
            <div className={"mt-3"}>
                <CustomTable
                    tableId={tableId}
                    searchId={searchId}
                    checkbox={listDisabled.length !== tbody?.data?.length }
                    thead={thead}
                    tbody={tbody}
                    columnActions={true}
                    getActionsButtons={getActionsButtons}
                    textNotInformation={"you_dont_have_any_requests_yet"}
                    selectedList={selectedList}
                    isAllChecked={isAllChecked}
                    handleCheckboxChange={handleCheckboxChange}
                    onChangeCheckbox={handleDeleteAll}
                    listDisabled={listDisabled}
                />
                {pagination()}
            </div>

            {showApprovedModal && (
                <CancelModal
                    show={showApprovedModal}
                    onHide={() => {
                        setShowApprovedModal(false);
                        setSelectedList([]);
                        setIsAllChecked(false);
                    }}
                    onConfirm={(e, comment) => {
                        handleApprovalAll(comment)
                    }}
                    requiredComment={false}
                    title_modal={"approve_request"}
                    description={t("are_you_sure_to_proceed")}
                    subDescription={t(getInfoParagraphByStatus(STATUS_MODEL.APPROVED))}
                />
            )}
        </>
    );
};

export default RequestMealTable;
